import { AppBar, Box, Hidden, IconButton, Tooltip } from "@material-ui/core";
import MenuOpenRoundedIcon from "@material-ui/icons/MenuOpenRounded";
import MenuRoundedIcon from "@material-ui/icons/MenuRounded";
import { Box as MuiBox } from "@mui/material";
import { styled } from "@mui/material/styles";
import clsx from "clsx";
import jwt_decode from "jwt-decode";
import React, { Fragment, useContext, useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import impersonationIcon from "../../../src/assets/admin_dashboard_image/impersonationIcon.svg";
import hoveredSunIcon from "../../../src/assets/USA_Images/login_images_visitor/hoveredSunIcon.svg";
import hoverMoonIcon from "../../../src/assets/USA_Images/login_images_visitor/hoverMoonIcon.svg";
import moonIcon from "../../../src/assets/USA_Images/login_images_visitor/moonIcon.svg";
import sunIcon from "../../../src/assets/USA_Images/login_images_visitor/sunIcon.svg";
import { REACT_DASHBOARD_PANEL, REACT_LOGIN } from "../../actions/EndPoints";
import Logo_Dealer from "../../assets/USA_Images/dealer/Logo_Dealer.svg";
import logo_smartgurd from "../../assets/USA_Images/login_images/AdminstrationDashBoard.svg";
import logo_smartgurd_customer from "../../assets/USA_Images/login_images/App-logo.svg";
import HeaderProfileMenu from "../../components/HeaderProfileMenu/HeaderProfileMenu";
import SwitchCompany from "../../components/SwitchCompany";
import Toast from "../../components/ToastContainer/CustomToast";
import HeaderLogo from "../../layout-components/HeaderLogo";
import { setSidebarToggleMobile } from "../../reducers/ThemeOptions";
import { getAccessToken } from "../../slices/DashboardPanel/DashboardPanelSlice";
import { revokeUser } from "../../slices/onboard/LoginSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import VisitorsExpiredEvents from "../../Pages/EventListeners/VisitorsExpiredEvents";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "../../ErrorFallBack/ErrorFallback";
const Icon = styled("img")({
  width: 24,
  height: 24,
});

const Header = (props) => {
  const [decodedJwtToken, setDecodedJwtToken] = useState(null);
  const [sidebarToggleMobile, setSidebarToggleMobile] = useState(
    props.sidebarToggleMobile
  );
  const { darkMode, setDarkMode } = useContext(ThemeContext);
  const dispatch = useDispatch();
  const storedRefreshToken = localStorage.getItem(
    process.env.REACT_APP_REFRESH_TOKEN
  );
  const [modehovered, setModeHovered] = useState(false);

  const handleThemeChange = () => {
    setDarkMode(!darkMode);
  };

  const handleStopImpersonation = async () => {
    try {
      dispatch(revokeUser());
      const data = await dispatch(getAccessToken(storedRefreshToken)).unwrap();
      if (data.code === "UASI0011") {
        localStorage.removeItem(process.env.REACT_APP_TEMP_TOKEN);
        localStorage.setItem(
          process.env.REACT_APP_ACCESS_TOKEN,
          "Bearer " + data.data.access_token
        );
        localStorage.setItem(
          process.env.REACT_APP_REFRESH_TOKEN,
          data.data.refresh_token
        );
        const decoded = jwt_decode(data.data.access_token);
        localStorage.setItem("companyId", decoded.companyId);
        localStorage.setItem("companyName", decoded.companyName);
        localStorage.setItem("companyType", decoded.companyType);
        localStorage.setItem("companyCode", decoded.companyCode);
        if (decoded.companyType === "NONE") {
          window.location.href = REACT_DASHBOARD_PANEL;
        }
      } else {
        Toast(data.message, "error");
      }
    } catch (error) {
      console.error("Error during impersonation stop:", error);
      Toast(
        "An error occurred while stopping impersonation. Please try again.",
        "error"
      );
    }
  };

  useEffect(() => {
    const accessToken = localStorage.getItem(
      process.env.REACT_APP_ACCESS_TOKEN
    );
    if (accessToken) {
      try {
        const decoded = jwt_decode(accessToken);
        setDecodedJwtToken(decoded);
      } catch (error) {
        console.error("Invalid access token:", error);
        window.location = REACT_LOGIN;
      }
    } else {
      window.location = REACT_LOGIN;
    }
  }, []);

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === process.env.REACT_APP_ACCESS_TOKEN) {
        if (event.newValue) {
          try {
            jwt_decode(event.newValue);
          } catch (error) {
            window.location = REACT_LOGIN;
          }
        } else {
          window.location = REACT_LOGIN;
        }
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const toggleSidebarMobile = () => {
    setSidebarToggleMobile(!sidebarToggleMobile);
    props.setSidebarToggleMobile(!sidebarToggleMobile);
  };

  const { headerShadow, headerFixed } = props;

  return (
    <Fragment>
      <AppBar
        color="secondary"
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "row",
          height: "68px",
          backgroundColor: process.env.REACT_APP_BG_HEADER_LOGO,
        }}
        className={clsx("app-header")}
        position={headerFixed ? "fixed" : "absolute"}
        elevation={headerShadow ? 11 : 3}
      >
        {!props.isCollapsedLayout && <HeaderLogo />}
        <Box
          style={{
            flex: 1,
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            backgroundColor: darkMode
              ? "#0B2E4D"
              : process.env.REACT_APP_BG_HEADTOOLBAR,
          }}
        >
          {decodedJwtToken?.companyType === "CUSTOMER" ? (
            <>
              <Hidden>
                <img
                  className="app-logo-img-customer"
                  src={logo_smartgurd_customer}
                  alt="mysmartguard"
                />
              </Hidden>
            </>
          ) : (
            <Hidden>
              <img
                className="app-logo-img-dealer-customer"
                src={
                  decodedJwtToken?.companyType === "NONE"
                    ? logo_smartgurd
                    : Logo_Dealer
                }
                alt="company logo"
              />
            </Hidden>
          )}
          <Box
            className="d-flex align-items-end"
            sx={{
              marginRight: "-25px",
            }}
          >
            {decodedJwtToken?.companyType === "CUSTOMER" && (
              <VisitorsExpiredEvents />
            )}

            {decodedJwtToken?.companyType === "CUSTOMER" && (
              <MuiBox display="flex" alignItems="center">
                {darkMode ? (
                  <Tooltip title="Light Mode">
                    <IconButton
                      onClick={handleThemeChange}
                      onMouseEnter={() => setModeHovered(true)}
                      onMouseLeave={() => setModeHovered(false)}
                    >
                      <Icon
                        src={modehovered ? hoveredSunIcon : sunIcon}
                        alt="Sun Icon"
                      />
                    </IconButton>
                  </Tooltip>
                ) : (
                  <Tooltip title="Dark Mode">
                    <IconButton
                      onClick={handleThemeChange}
                      onMouseEnter={() => setModeHovered(true)}
                      onMouseLeave={() => setModeHovered(false)}
                    >
                      <Icon
                        src={modehovered ? hoverMoonIcon : moonIcon}
                        alt="Moon Icon"
                      />
                    </IconButton>
                  </Tooltip>
                )}
              </MuiBox>
            )}
            {decodedJwtToken?.tokenType &&
              (decodedJwtToken?.companyType === "CUSTOMER" ||
                decodedJwtToken?.companyType === "PARTNER") && (
                <MuiBox
                  display="flex"
                  alignItems="center"
                  sx={{
                    marginRight:
                      decodedJwtToken?.companyType === "PARTNER" ? "16px" : "",
                  }}
                >
                  <Tooltip title="Stop Impersonation">
                    <IconButton onClick={handleStopImpersonation}>
                      <Icon
                        src={impersonationIcon}
                        alt="Impersonation Stop Icon"
                      />
                    </IconButton>
                  </Tooltip>
                </MuiBox>
              )}

            <SwitchCompany />
            <HeaderProfileMenu />
            <Box className="toggle-sidebar-btn-mobile">
              <IconButton
                color="inherit"
                onClick={toggleSidebarMobile}
                size="medium"
              >
                {sidebarToggleMobile ? (
                  <MenuOpenRoundedIcon />
                ) : (
                  <MenuRoundedIcon />
                )}
              </IconButton>
            </Box>
          </Box>
        </Box>
      </AppBar>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  headerShadow: state.ThemeOptions.headerShadow,
  headerFixed: state.ThemeOptions.headerFixed,
  sidebarToggleMobile: state.ThemeOptions.sidebarToggleMobile,
});

const mapDispatchToProps = (dispatch) => ({
  setSidebarToggleMobile: (enable) => dispatch(setSidebarToggleMobile(enable)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
